export default "__VITE_ASSET__218cde3f__"